import { z } from 'zod'
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools'
import { isValidMobileNumber } from '@/utils/function'

export const FormSchema = z.object({
  mobile_number: z
    .string({ required_error: 'وارد کردن شماره موبایل الزامی است' })
    .transform((input) => digitsArToEn(digitsFaToEn(input)))
    .refine((data) => isValidMobileNumber(data), {
      message: 'شماره موبایل وارد شده معتبر نیست',
    }),
  referral_code: z.string().optional(),
})

export type FormModel = z.infer<typeof FormSchema>
